import { useState, useEffect } from 'react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import PDFDisplay from './PDFDisplay';

const DocumentViewer = ({ documentId, description }) => {
  const { currentUser } = useAuth();
  const [documentUrl, setDocumentUrl] = useState('');
  const [error, setError] = useState(null);

  // Fetch document URL from Firebase Storage
  useEffect(() => {
    if (!currentUser) {
      setError('You must be logged in to view this document.');
      return;
    }

    const fetchDocumentUrl = async () => {
      try {
        const folder = 'private';
        const storage = getStorage();
        const documentRef = ref(storage, `docs/${folder}/${documentId}.pdf`);
        const url = await getDownloadURL(documentRef);
        setDocumentUrl(url);
      } catch (err) {
        console.error('Error fetching document URL:', err);
        setError('Failed to load document.');
        setDocumentUrl('');
      }
    };

    fetchDocumentUrl();
  }, [documentId, currentUser]);

  return (
    <Box
      sx={{
        maxWidth: '800px',
        mx: 'auto',
        mt: 2,
        position: 'relative',
        width: '100%',
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      <PDFDisplay url={documentUrl} description={description} />
    </Box>
  );
};

export default DocumentViewer;